import { t } from 'i18next';
import { Box, SvgIcon, Tooltip } from '@mui/material';
import { Button } from '@atoms';
import styles from './styles';

export interface ActionButtonProps {
  tooltip: string;
  icon: React.ReactNode;
  callback: () => void;
  show: boolean;
}

/**
 * Icon button for table action columns
 * @param tooltip text to show on tooltip
 * @param icon icon to render inside button
 * @param callback function to trigger on button click
 * @param show if true renders the button, if false renders an empty fragment
 */
const ActionButton = ({ tooltip, icon, callback, show }: ActionButtonProps) => {
  if (!show) return <></>;
  return (
    <Tooltip title={t(tooltip)} arrow>
      <Box>
        <Button
          customStyle={{
            button: styles.button,
            box: styles.box,
          }}
          onClick={callback}
          content={<SvgIcon fontSize='medium'>{icon}</SvgIcon>}
        />
      </Box>
    </Tooltip>
  );
};

export default ActionButton;
